module.exports = __webpack_public_path__ + "static/media/ipo1.1ae2ed0c.png";